import React, { useContext, useEffect } from 'react'
import { MapContext } from '../map'
import { GeoJSONSource, SourceSpecification } from 'maplibre-gl'
import { AnyLayer } from '../types'
import { useDispatch } from 'react-redux'
import { increaseUpdateCount } from 'store/DNLayersSlice'
import { getDNLayerByID } from 'services/apiRequests'
import { useParams } from 'react-router-dom'
import { feature, featureCollection, MultiPolygon } from '@turf/turf'

interface IDNLayerProps {
  id: string
  layer: AnyLayer
  source: { [p: string]: SourceSpecification }
}

export const DNLayer: React.FC<IDNLayerProps> = (props) => {
  const mapContext = useContext(MapContext)
  const { id } = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    id &&
      getDNLayerByID(id, props.id).then((res) => {
        const source = mapContext?.getSource(Object.keys(props.source)[0])
        source &&
          (source as GeoJSONSource).setData(featureCollection([feature(res.data.geometry as unknown as MultiPolygon)]))
      })
  }, [id, props.id])

  useEffect(() => {
    const sourceId = Object.keys(props.source)[0]
    !mapContext?.getSource(sourceId) && mapContext?.addSource(sourceId, props.source[sourceId])
    !mapContext?.getLayer(props.layer.id) && mapContext?.addLayer(props.layer, 'points-ruler-line')
    dispatch(increaseUpdateCount())
    return () => {
      mapContext?.getSource(sourceId) && mapContext?.removeLayer(props.layer.id)
      mapContext?.getLayer(props.layer.id) && mapContext?.removeSource(sourceId)
    }
  }, [])

  return <></>
}
